import axios from "@/axios";

/**
 * 登录
 */
export function companyLogin(parameter) {
  return axios.formRequest.post("admin/company/company_Login", {
    data: JSON.stringify(parameter)
  });
}

/**
 * 登出
 */
export function companyLogout() {
  return axios.formRequest.post("admin/company/logout", {});
}

/**
 * 获取登录企业信息
 */
export function getCompanyInfo() {
  return axios.formRequest.post("/admin/company/company_info", {});
}

/**
 * 服务器/ftp维护获取
 */
export function getCompanyServer() {
  return axios.formRequest.post("admin/company/get_company_server", {});
}

/**
 * 服务器/ftp维护设置
 */
export function companySetServer(parameter) {
  return axios.formRequest.post("admin/company/company_set_server", {
    data: JSON.stringify(parameter)
  });
}

/**
 * 直连经销商管理 获取经销商列表
 */
export function getClientConnect(parameter) {
  return axios.formRequest.post("admin/client/getClient_connect", parameter);
}

/**
 * 直连经销商管理 更改用户名密码
 */
export function clientSetNamePwd(
  client_id,
  client_plugin_name,
  client_plugin_password
) {
  return axios.formRequest.post("admin/client/set_Name_Pwd", {
    data: JSON.stringify({
      client_id,
      client_plugin_name,
      client_plugin_password
    })
  });
}

/**
 * 直连经销商管理 获取未直连经销商列表接口
 * 选择经销商
 */
export function clientGetClient(page = 1, find_value, scrap_type) {
  return axios.formRequest.post("admin/client/getClient", {
    page,
    find_value,
    scrap_type
  });
}

/**
 * 直连经销商管理 添加直连经销商
 */
export function directConnectionClient(parameters) {
  return axios.formRequest.post("admin/client/direct_connection_client", parameters);
}

/**
 * 直连经销商管理 删除直连经销商
 */
export function delClient(client_id) {
  return axios.formRequest.post("admin/client/del_client", { client_id });
}

/**
 * 直连经销商管理 解绑直连经销商
 */
export function unbindClient(client_id) {
  return axios.formRequest.post("admin/client/update_status", { client_id });
}

/**
 * 直连经销商管理 获取插件期间
 */
export function getPeriod() {
  return axios.formRequest.post("admin/period/get_period", {});
}

/**
 * 直连经销商管理 插件设置期间
 */
export function setPeriod(parameter) {
  return axios.formRequest.post("admin/period/set_period", {
    data: JSON.stringify(parameter)
  });
}

/**
 * 直连经销商管理 临时抓取任务列表
 */
export function getqueryPageList(parameter) {
  return axios.formRequest.post("admin/temporary/queryPageList", parameter);
}
/**
 * 终止临时抓取任务
 */
export function stopTemporary(parameter) {
  return axios.formRequest.post("admin/temporary/stopTemporary", parameter);
}

/**
 * 直连经销商管理 临时抓取任务列表 选择经销商
 */
export function temporaryGetClientList(page, find_value, scrap_type) {
  return axios.formRequest.post("admin/temporary/get_client_list", {
    page,
    find_value,
    scrap_type
  });
}

/**
 * 直连经销商管理 添加临时抓取任务
 */
export function addTemporary(parameter) {
  return axios.formRequest.post("admin/temporary/add_temporary", {
    data: JSON.stringify(parameter)
  });
}

/**
 * 直连经销商管理 文件拆分列表
 */
export function splitFileList(type, search_text) {
  return axios.formRequest.post("admin/splitfile/split_file_list", {
    type,
    search_text
  });
}

/**
 * 直连经销商管理 文件拆分详情
 */
export function getSplitFileInfo(client_id, type) {
  return axios.formRequest.post("admin/splitfile/get_split_file_info", {
    data: JSON.stringify({ client_id, type })
  });
}

/**
 * 直连经销商管理 提交
 */
export function addSplitfile(parameter) {
  return axios.formRequest.post("admin/splitfile/add_splitfile", {
    data: JSON.stringify(parameter)
  });
}

/**
 * 监控管理 插件监控器
 */
export function pluginList(
  page,
  find_value,
  connect_type,
  plugin_type,
  page_size
) {
  return axios.formRequest.post("admin/plugin/pluginPageList", {
    page,
    find_value,
    connect_type,
    plugin_type,
    page_size
  });
}

/**
 * 监控管理 网站抓取监控
 */
export function showWebscrapLog(parameter) {
  return axios.formRequest.post(
    "admin/webscrap/queryWebScrapLogPage",
    parameter
  );
}

/**
 * 原始文件查询 上传文件查询
 */
export function uploadfileLogList(parameter) {
  return axios.formRequest.post(
    "admin/uploadfilelog/uploadfile_log_list",
    parameter
  );
}

/**
 * 网站抓取管理 获取插件期间
 */
export function getWebScrapPeriod(parameter) {
  return axios.formRequest.post("admin/period/get_web_scrap_period", parameter);
}

/**
 * 网站抓取管理 插件设置期间
 */
export function setWebScrapPeriod(parameter) {
  return axios.formRequest.post("admin/period/set_web_scrap_period", parameter);
}

/**
 * 网站抓取管理 网站抓取管理
 */
export function webscrapGetList() {
  return axios.formRequest.post("admin/webscrap/get_list", {});
}

/**
 * 网站抓取管理 网站抓取管理 设置账号
 */
export function saveWebscrap(parameter) {
  return axios.formRequest.post("admin/webscrap/save_webscrap", {
    data: JSON.stringify(parameter)
  });
}

/**
 * 网站抓取管理 网站抓取管理 获取账号信息 用户名 密码
 */
export function webscrapGetAccount(client_code) {
  return axios.formRequest.post("admin/webscrap/get_account", { client_code });
}

/**
 * 网站抓取管理 网站抓取管理 直连网站管理 设置经销商
 */
export function webscrapSetBroker(parameter) {
  return axios.formRequest.post("admin/webscrap/set_broker", {
    data: JSON.stringify(parameter)
  });
}

/**
 * 网站抓取管理 选择经销商
 */
export function getBrokerList(page, find_value, scrap_type) {
  return axios.formRequest.post("admin/splitfile/get_broker_list", {
    page,
    find_value,
    scrap_type
  });
}

/**
 * 获取所有经销商
 */
export function getAllClient(page, find_value, scrap_type) {
  return axios.formRequest.post("/admin/client/getAllClient", {
    page,
    find_value,
    scrap_type
  });
}

/**
 * 文件拆分-删除
 * type 0：插件数据 1：网抓数据
 */
export function delSplitfile(paramater) {
  return axios.formRequest.post("/admin/splitfile/del_splitfile", {
    data: JSON.stringify(paramater),
  });
}
/**
 * 查看日志
 */
export function viewLog(parameters) {
  return axios.formRequest.post("/admin/plugin/plugin_log_list", parameters);
}

/**
 * 网抓上传数据
 */
export function getWebScrapList(parameters) {
  return axios.formRequest.post("/admin/webscrap/getWebScrapList", parameters);
}
/**
 * 邮件抓取商业公司列表
 */
export function emailConnectList(is_broker, page) {
  return axios.formRequest.post("/admin/email/emailConnectList", {
    is_broker,
    page
  });
}
/**
 * 邮件抓取商业公司列表
 */
export function chooseClient(page, find_value, scrap_type) {
  return axios.formRequest.post("/admin/email/chooseClient", {
    page,
    find_value,
    scrap_type
  });
}
/**
 * 设置映射的商业公司
 */
export function setBrokerClient(parameters) {
  return axios.formRequest.post("/admin/email/setBrokerClient", parameters);
}
/**
 * 邮件抓取日志列表
 */
export function emailLogList(page) {
  return axios.formRequest.post("/admin/email/emailLogList", { page });
}
/**
 * 编辑彩蝶对接设置
 */
export function setSetting(config) {
  return axios.formRequest.post("/admin/client/setSetting", { config });
}
/**
 * 获取彩蝶对接设置
 */
export function getSetting(parameters) {
  return axios.formRequest.post("/admin/client/getSetting", parameters);
}
/**
 * 获取ftp关联商业
 */
export function getFtpClientList(page, search_text, scrap_type) {
  return axios.formRequest.post("/admin/splitfile/getFtpClientList", {
    page,
    search_text,
    scrap_type
  });
}
/**
 * 设置ftp日期过滤配置
 */
export function setFtpDateSetting(parameters) {
  return axios.formRequest.post("/admin/client/setFtpDateSetting", parameters);
}
/**
 * 插件控制器各类报告以及连接配置信息
 */
export function pluginGetTemporary(parameter) {
  return axios.formRequest.post("admin/plugin/get_temporary", parameter);
}
/**
 * 设置插件sql
 */
export function set_temporary(data) {
  return axios.formRequest.post("admin/plugin/set_temporary", { data });
}
/**
 * 多账号网抓档案列表
 */
export function getMultipleWebscrap(data) {
  return axios.formRequest.post("admin/webscrap/getMultipleWebscrap", data);
}
/**
 * 网抓账号列表
 */
export function webscrapAccountList(data) {
  return axios.formRequest.post("admin/webscrap/webscrapAccountList", data);
}

/**
 * 合并进彩蝶
 */
export function mergeFiles(data) {
  return axios.formRequest.post("admin/webscrap/mergeFiles", data);
}

/**
 * 网抓查看原始数据
 */
export function webscrapDataList(data) {
  return axios.formRequest.post("admin/webscrap/webscrapDataList", data);
}

/**
 * 新拆分获取档案接口
 */
export function get_new_broker_list(page, find_value, scrap_type) {
  return axios.formRequest.post("admin/splitfile/get_new_broker_list", {
    page,
    find_value,
    scrap_type,
  });
}

/**
 *  新网站监控接口
 */
export function show_new_webscrap_log(data) {
  return axios.formRequest.post("admin/webscrap/queryNewWebScrapLogPage", data);
}
/**
 *  商业公司网抓初始化数据列表查询
 */
export function webScrapClientInitList(parameter) {
  return axios.formRequest.post("admin/web_scrap_client_init/getList", {
    data: JSON.stringify(parameter)
  });
}
/**
 *  商业公司网抓初始化数据列表状态查询 枚举类
 */
export function enumBusinessList(data) {
  return axios.formRequest.post("enums/enum_business/getEnumList", data);
}

/**
 *  添加商业公司网抓初始化数据
 */
export function AddwebScrapClientInit(parameter) {
  return axios.formRequest.post("admin/web_scrap_client_init/add", {
    data: JSON.stringify(parameter)
  });
}
/**
 *  添加商业公司网抓初始化数据
 */
export function SplitgetSplitFileInfo(
  search_text,
  client_id,
  type,
  broker_code
) {
  return axios.formRequest.post("admin/splitfile/get_split_file_info", {
    data: JSON.stringify({ search_text, client_id, type, is_subsidiary_unique: '1', broker_code })
  });
}

/**
 *  选择经销商 区分新流程和旧流程（新）
 */
export function getClientPage(data) {
  return axios.formRequest.post("admin/webscrap/getClientPage", data);
}

/**
 *  编辑插件信息接口
 */
export function editPluginConnect(data) {
  return axios.formRequest.post("admin/plugin/editPluginConnect", data);
}

/**
 *  设置母公司原始名称
 */
export function setParentOriginalNames(client_id, parent_original_names, type, function_name) {
  return axios.formRequest.post("admin/splitfile/setParentOriginalNames", {
    data: JSON.stringify({ client_id, parent_original_names, type }),
    function_name
  });
}

/**
 *  历史月数据采集列表查询
 */
export function getMonthPage(parameter) {
  return axios.formRequest.post("admin/history_reriod_month/getPage", {
    data: JSON.stringify(parameter)
  });
}

/**
 *  历史月数据采集列表删除
 */
export function monthPageCancel(parameter) {
  return axios.formRequest.post("admin/history_reriod_month/cancel", parameter);
}

/**
 *  历史月数据采集添加
 */
export function monthAdd(parameter) {
  return axios.formRequest.post("admin/history_reriod_month/add", parameter);
}

/**
 *  商业公司FTP列表查询
 */
export function ftpPage(parameter) {
  return axios.formRequest.post("admin/client/ftpPage", parameter);
}
/**
 * 省份数据
 */
export function regionList(parameter) {
  return axios.formRequest.post("admin/client/regionList", parameter);
}

/**
 * 系统设置-操作日志
 */
export function getLogPage(parameter) {
  return axios.formRequest.post("admin/operate_log/getPage", parameter);
}

/**
 * 获取详情
 */
export function qrCodeLogin(parameter) {
  return axios.formRequest.post("admin/company/qrCodeLogin", parameter);
}

/**
 * 企业流连宝企业列表
 */
export function companyPwdLogin(parameter) {
  return axios.formRequest.post("admin/company/companyPwdLogin", parameter);
}

/**
 * 新建任务 获取sql
 */
export function getLastExecSql(parameter) {
  return axios.formRequest.post("admin/temporary/getLastExecSql", parameter);
}


/**
 * 新建任务 获取sql
 */
export function getOperateDetailLogList(parameter) {
  return axios.formRequest.post("admin/operate_log/getOperateDetailLogList", parameter);
}

/**
 * 创建直连历史月采集任务-批量添加临时任务
 */
export function multipleAddTemporary(parameter) {
  return axios.formRequest.post("admin/temporary/multipleAddTemporary", parameter)
    .catch(error => {
      console.error('创建任务失败:', error);
      return Promise.reject(error);
    });
}

export function adminTemporaryDownloadTempFile(parameter) {
  return axios.formRequest.post("admin/temporary/downloadTempFile", parameter);
}